const driversViewIframe = {
  bindings: {
    settings: '<',
    view: '<',
    gridlet: '<',
  },
  templateUrl: '/modules/gridlets/drivers-view-iframe/drivers-view-iframe.html',
  controller: 'DriversViewIframeController',
};

angular
  .module('gridlets.module')
  .component('driversViewIframe', driversViewIframe);